import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog } from '@headlessui/react'
import { IKImage } from 'imagekitio-react'
import React, { useEffect } from 'react'
import { sendPricingGoal } from '../../../redux/actions/pricing';
import { useDispatch, useSelector } from 'react-redux';


const careerGoals = [{ goal_name : 'Certifications' , product : "LearnTube Pro", product_plans_id : 1 }, {goal_name : 'Practical Learning' , product: "LearnTubeX" ,product_plans_id : 4}, { goal_name :'Placements' , product:"LearnTube Max", product_plans_id : 2}];
const CareerModal = ({isModalEnabled , setIsModalEnabled ,setIsCareerGoal,isSetGoal }) => {
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const dispatch = useDispatch();
  useEffect(()=>{
    
    if(isSetGoal){
      setIsModalEnabled(false);
    }

  },[isSetGoal])
  return (
    <Dialog
    open={isModalEnabled}
    onClose={() => null }
    as="div"
    className="fixed inset-0 z-10 flex flex-col  items-center justify-center overflow-y-auto"
  >
    <Dialog.Overlay className="fixed inset-0 z-10 bg-black opacity-70" />                                                 
    <Dialog.Title />
    <Dialog.Description />
    <div className="relative z-10 flex  w-11/12 flex-col items-center justify-center overflow-auto rounded-xl bg-white py-4 px-4 text-center shadow-2xl  md:w-1/4 md:p-4 lg:w-1/4">
      <img
        urlEndpoint="https://assets.learntube.ai/files/"
        src={
          "https://assets.learntube.ai/files/PRICING/Group_8188.svg?updatedAt=1684559713569"
        }
        transformation={[
          {
            height: "100",
            width: "100",
          },
        ]}
        className="w-[242px] h-[242px] -mt-1"
      />
      <div className='text-xl font-bold -mt-4'>Let Us Help You Select A Plan</div>
      <div className='mt-5 self-start text-md font-medium px-2'>What do you want to Achieve</div>
      <div className="mt-2 w-full flex flex-col justify-center items-center text-md font-medium ">
                {careerGoals?.map((goal,index) => (
                  <div
                    className="flex cursor-pointer w-full px-2 py-2 items-center gap-2 overflow-hidden rounded-lg border-2 mb-1 bg-white text-gray-700 hover:text-white hover:bg-[#086788]"
                    key={index}
                    onClick={() => {
                      setIsModalEnabled(false);
                      setIsCareerGoal((prev)=> ({...prev , is_show : true , selected_goal : goal}))
                      if(user_role === 7){
                      dispatch(sendPricingGoal(goal?.product_plans_id))
                      }
                    }}
                  >
                   
                    <p className="text-center font-semibold ">
                      {goal?.goal_name}
                    </p>
                    <div className="flex-1"></div>
                    <FontAwesomeIcon
                      icon={faAngleRight}
                      size="xl"
                      className="mr-3 text-gray-700"
                    />
                  </div>
                ))}
              </div>
              
     </div>
  </Dialog>
  )
}

export default CareerModal
